import React from 'react';
import { IDataBox } from '../DataBox.types';
import { Title } from '../DataBox.styles';

export default function DataBoxTitle({ children, testId = 'data-box-title' }: IDataBox) {
  return <Title data-testid={testId}>{children}</Title>;
}
